import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text, View } from "react-native";
import { connect } from "react-redux";

import PatientField from "./PatientField";

import fonts from "../constants/fonts";

class PatientDetailMore extends React.Component {
  static propTypes = {
    class: PropTypes.string,
    gender: PropTypes.oneOf(["f", "m"]).isRequired,
    height: PropTypes.number,
    onEditPress: PropTypes.func,
    organization: PropTypes.string.isRequired,
    weight: PropTypes.number,
    age: PropTypes.number,
  };

  render() {
    const {
      gender,
      height,
      onEditPress,
      weight
    } = this.props;

    const genders = {
      f: I18n.t("prixa.female"),
      m: I18n.t("prixa.male")
    };

    return (
      <>
        {/* <Text
          style={[
            styles.organization,
            {
              color: themeColors.darkestPrimary
            }
          ]}
        >
          {organization.toUpperCase()}
        </Text> */}
        <View style={styles.rowContainer}>
          <PatientField
            containerStyle={styles.halfWidth}
            label={I18n.t("prixa.gender")}
            value={genders[gender]}
          />
          <PatientField
            containerStyle={styles.halfWidth}
            label={I18n.t("prixa.age")}
            value={this.props.age === null || this.props.age === undefined 
              ? '-' : `${this.props.age} ${I18n.t("prixa.ageText")}`}
          />
        </View>
        <View style={styles.rowContainer}>
          <PatientField
            containerStyle={styles.halfWidth}
            editable={true}
            label={"Tinggi Badan"}
            onEditPress={onEditPress}
            value={height ? `${height} cm` : "-"}
          />
          <PatientField
            containerStyle={styles.halfWidth}
            editable={true}
            label={"Berat Badan"}
            onEditPress={onEditPress}
            value={weight ? `${weight} kg` : "-"}
          />
        </View>
      </>
    );
  }
}

const styles = StyleSheet.create({
  fullWidth: {
    flex: 1
  },
  halfWidth: {
    flex: 0.5
  },
  organization: {
    fontSize: 16,
    marginBottom: 10,
    textAlign: "center",

    ...fonts.bold
  },
  rowContainer: {
    flexDirection: "row",
    marginBottom: 10
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(PatientDetailMore);
